<template>
	<BaseModal :show="show">
		<form class="flex flex-col max-w-90">
			<div class="flex items-center space-x-2">
				<img v-if="props.icon === 'alert'" src="@/assets/images/icon/modal/alert.svg" class="size-8" alt="Alert" />
				<img v-if="props.icon === 'info'" src="@/assets/images/icon/modal/warning.svg" class="size-8" alt="Warning" />
				<img v-if="props.icon === 'error'" src="@/assets/images/icon/toast/error.svg" class="size-8" alt="Error" />

				<p class="text-xl font-bold text-heading">{{ props.title }}</p>
			</div>

			<p class="leading-6 text-grayscale-body mt-3" v-html="props.message"/>
			<p v-if="subMessage !== ''" class="leading-6 text-label mt-2 text-sm font-bold" v-html="props.subMessage"/>

			<div class="flex flex-row mt-5 ml-auto space-x-4">
				<SubmitButton v-for="buttonData in buttons"
					:key="buttonData.label"
					:type="buttonData.type"
					:size="buttonData.size"
					:label="buttonData.label"
					:disabled="buttonData.isLoading"
					:loading="buttonData.isLoading"
					@click.prevent="buttonData.onClick"
				/>
			</div>
		</form>
	</BaseModal>
</template>

<script setup lang="js">
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import BaseModal from '@/components/Alerts/BaseModal.vue'

const props = defineProps({
	show: { type: Boolean, default: false },
	icon: {
		type: String,
		default: 'alert',
		validator(value)
		{
			return ['none', 'alert', 'info', 'error'].includes(value)
		}
	},
	title: { type: String, default: '' },
	message: { type: String, default: '' },
	subMessage: { type: String, default: '' },
	buttons: { type: Array, default: () => [] },
})

</script>